import { EmployeeApi } from 'api/EmployeeApi';
import { backendApiClient } from 'container/backendApiClient';

export const employeeApi = new EmployeeApi(backendApiClient);
